module.exports = __webpack_public_path__ + "img/蒙版组-23.a35a835d.jpg";